import {
  isUserWithRoles, useCombinedUser, useDelayCall, useIsMsalAuth, UserRoles,
  useStickySafeNavigate,
} from '@equifinance/shared';
import BrokerManagement from '../pages/BrokerManagement';
import { BrokeragesProvider } from '../contexts/brokerages';

export function BrokerManagementRoutes() {
  const isInternalUser = useIsMsalAuth();
  const { user } = useCombinedUser();
  const navigate = useStickySafeNavigate();

  const isUnderwriter = isInternalUser && isUserWithRoles([UserRoles.UNDERWRITER], user);
  const isSalesSupport = isInternalUser && isUserWithRoles([UserRoles.SALES_SUPPORT], user);
  const isDBM = isInternalUser && isUserWithRoles([UserRoles.BDM], user);
  const isReadOnly = isInternalUser && isUserWithRoles([UserRoles.READ_ONLY], user);

  const allowedAccess = isUnderwriter || isSalesSupport || isDBM || isReadOnly;

  useDelayCall(() => {
    if (!allowedAccess) {
      navigate('/403');
    }
  }, [allowedAccess], true);

  return (
    <BrokeragesProvider>
      {allowedAccess && <BrokerManagement />}
    </BrokeragesProvider>
  );
}
